import { CeeProcessingStatus, DovaStatus, InternalAuditStatus } from "app/shared/enumerations/statuses.enum";

export class AcepDossier {
  id: number = null;
  guidId: string = null;
  typeDossier : string = null; 
  refDossier : string = null; 
  isDovaRunning : boolean = false;  
  status: string = null;
  dovaStatus?: DovaStatus;
  ceeProcessingStatus: CeeProcessingStatus;
  internalAuditStatus?: InternalAuditStatus;
  partnerName: string = null;
  mandataireName: string = null;
  operatorName: string = null;
  controllerName: string = null;
  beneficiaryFullName: string = null;
  beneficiaryNature: string = null;
  beneficiaryEmail: string = null;
  volume?: number = null;
  operatorAssignmentSince?:number = null;
  controllerAssignmentSince?:number = null;
  createdSince:number = null;
  createdBy: string = null;
  createdOnUtc?: Date = null;
  isOnTera: boolean = false;
  priority: string = null;
  isUrgencyFlag: boolean = false;
  urgencyFlagReasonId?: string = null;
  urgencyFlagReasonLabel?: string = null;
  urgencyFlagComment?: string = null;
  urgencyFlagDate?: Date = null;
  urgencyFlagBy?: string = null;
  anomalyTags: string[] = [];
  incompletudeTags: string[] = [];

  constructor(init?: Partial<AcepDossier>) {
    Object.assign(this, init);
  }
}
